export const PuissanceMonophase = [
    { key: "3A", value: "3A", label: "3A" },
    { key: "5A - 15A", value: "5A - 15A", label: "5A - 15A" },
    { key: "10A - 30A", value: "10A - 30A", label: "10A - 30A" },
  ];
  
  export const PuissanceTriphase = [
    { key: "10A - 30A", value: "10A - 30A", label: "10A - 30A" },
    { key: "DT", value: "DT", label: "Double tarif (> 30A)" },
  ];